/** Per-agent UTM-style tracker.
 * Fires events to `/api/analytics/track` for views and outbound WhatsApp/Call clicks.
 * Uses `fetch(..., {keepalive: true})` so the event still flies during link navigation.
 */
import api, { API } from "@/lib/api";

export async function track(event) {
  if (!event?.agent_slug || !event?.event_type) return;
  try {
    // keepalive ensures the request survives a click->navigate
    await fetch(`${API}/analytics/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...event,
        referrer: typeof document !== "undefined" ? document.referrer : null,
      }),
      keepalive: true,
    });
  } catch {
    // never block UX on telemetry failure
  }
}

/** Append UTM params (idempotent) to an outbound URL like wa.me or tel: */
export function withUtm(url, { agent_slug, project_id, source = "microsite" } = {}) {
  if (!url) return url;
  // Don't tamper with tel: links — they ignore query strings on most dialers
  if (url.startsWith("tel:")) return url;
  try {
    const u = new URL(url);
    if (agent_slug) u.searchParams.set("utm_source", "inpropportal");
    if (agent_slug) u.searchParams.set("utm_medium", source);
    if (agent_slug) u.searchParams.set("utm_campaign", agent_slug);
    if (project_id) u.searchParams.set("utm_content", project_id);
    return u.toString();
  } catch {
    return url;
  }
}

export const summary = (days = 30) =>
  api.get("/analytics/summary", { params: { days } }).then((r) => r.data);
